import { useMemo } from 'react';

import { useSelectedStore } from '@web/app/shared';

import { useProjects } from '@codes/project';
import { useWorkspace } from '@codes/workspace';

export const useProjectService = () => {
    const { workspace, project } = useSelectedStore();
    const { data: workspaceFromServer } = useWorkspace('0');

    const myProjectsQueryResult = useProjects(workspaceFromServer?.id as string, {
        limit: 50,
        page: 0,
    });

    const myProjects = useMemo(() => {
        return !!myProjectsQueryResult.data && !!myProjectsQueryResult.data.data ? myProjectsQueryResult.data.data : [];
    }, [myProjectsQueryResult.data]);

    const areMyProjectsEmpty =
        !!myProjectsQueryResult.data && !!myProjectsQueryResult.data.data && myProjectsQueryResult.data.total === 0;

    return {
        myProjectsQueryResult,
        myProjects,
        areMyProjectsEmpty,
        myProject: project,
    };
};
